import { useState } from 'react'

import type { UseDeleteAccountModalReturn, DeleteAccount } from './useDeleteAccountModal.types'

export function useDeleteAccountModal(): UseDeleteAccountModalReturn {
  const [selectedAccount, setSelectedAccount] = useState<DeleteAccount | undefined>(undefined)

  const openModal = (account: DeleteAccount) => {
    setSelectedAccount(account)
  }

  const closeModal = () => {
    setSelectedAccount(undefined)
  }

  return {
    selectedAccount,
    isModalOpen: !!selectedAccount,
    openModal,
    closeModal
  }
}
